export const languageLocalizationMap: Record<number, string> = {
  0: 'de',
  1: 'en',
  2: 'en'
};
